import _ from "lodash";
import numeral from "numeral";

export const percents = ({ value }: { value: number | null }) =>
    `${_.isNumber(value) ? `${numeral(Math.abs(value)).format("0.[00]%")}` : "NA"}`;

export const clearURl = (url: string) => url.replace(/%2F/g, "%252F");
